var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, IconButton, Link, LoadingButton, TextField, } from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { EditDeliveryInstructionsApi } from '../../../api/omm/edit-delivery-instructions';
import { EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE, instructionsPlaceholder, } from '../../../constants/editDeliveryInstructions';
import { useExperienceContext, useEditDeliveryInstructionsContext, useOrderContext, } from '../../../hooks/useContexts';
import { DELIVERY_TYPE_STATUS, } from '../../../models/delivery-instructions';
import '../../../styles/drawer.scss';
import { catchEditDeliveryInstructionsPostPageLoadError, catchEditDeliveryInstructionsUpdated, } from '../../../utils/edit-delivery-instructions/analytics';
import { getWindow } from '../../../utils/general';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { ProOrderUpForm } from './ProOrderUpForm';
export var EditDeliveryInstructionsDrawer = function (props) {
    var _a;
    var setShowDrawerError = useOrderContext().setShowDrawerError;
    var toggleDrawer = props.toggleDrawer;
    var _b = useEditDeliveryInstructionsContext(), deliveryInstructions = _b.deliveryInstructions, setDeliveryInstructions = _b.setDeliveryInstructions, deliveryType = _b.deliveryType, setDeliveryType = _b.setDeliveryType, propertyTypesList = _b.propertyTypesList, securityCode = _b.securityCode, setSecurityCode = _b.setSecurityCode, lockboxLocation = _b.lockboxLocation, setLockboxLocation = _b.setLockboxLocation, lockboxCode = _b.lockboxCode, setLockboxCode = _b.setLockboxCode, preferredPackagePlacement = _b.preferredPackagePlacement, setPreferredPackagePlacement = _b.setPreferredPackagePlacement, propertyType = _b.propertyType, setPropertyType = _b.setPropertyType, siteConditions = _b.siteConditions, setSiteConditions = _b.setSiteConditions, additionalInstructions = _b.additionalInstructions, setAdditionalInstructions = _b.setAdditionalInstructions, otherPropertyType = _b.otherPropertyType, setOtherPropertyType = _b.setOtherPropertyType, hasStairs = _b.hasStairs, setHasStairs = _b.setHasStairs, setTrucks36Foot = _b.setTrucks36Foot, deliveryInstructionInfo = _b.deliveryInstructionInfo, open = _b.editDeliveryInstructionsDrawerOpen;
    var _c = deliveryInstructionInfo.previousSiteInstructions || {}, previousPreferredPackagePlacement = _c.preferredPackagePlacement, previousDeliverySecurity = _c.deliverySecurity, previousLockboxCode = _c.lockboxCode, previousLockboxLocation = _c.lockboxLocation, previousPropertyType = _c.propertyType, previousHasStairs = _c.hasStairs, previousTrucks36Foot = _c.trucks36Foot, previousComments = _c.comments, previousSiteConditions = _c.siteConditions;
    var primaryPropertyType = propertyTypesList.find(function (type) {
        return type.toLowerCase() === (previousPropertyType === null || previousPropertyType === void 0 ? void 0 : previousPropertyType.toLowerCase());
    });
    var booleanStairs = null;
    var booleanTrucks = false;
    switch (previousHasStairs) {
        case 'Y':
            booleanStairs = true;
            break;
        case 'N':
            booleanStairs = false;
            break;
        default:
            booleanStairs = null;
    }
    /* Order Up phrases this as 36 foot trucks *cannot* be accommodated and codes this as Y if checkbox is selected
    so Y is "cannot accommodate" and N is "can accommodate" */
    switch (previousTrucks36Foot) {
        case 'Y':
            booleanTrucks = true;
            break;
        case 'N':
            booleanTrucks = false;
            break;
        default:
            booleanTrucks = false;
    }
    var previousDeliveryInstructions = deliveryInstructionInfo.deliveryInstructions;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _d = useState(false), loading = _d[0], setLoading = _d[1]; // For Loading Button
    var _e = useState(null), alertState = _e[0], setAlertState = _e[1];
    var _f = useState(false), reload = _f[0], setReload = _f[1];
    var _g = useState(false), showSurvery = _g[0], setShowSurvey = _g[1];
    var _h = useThdCustomer(), isLoggedIn = _h.isLoggedIn, isExchangeCustomer = _h.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var isIos = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var closeDrawer = function () {
        var _a, _b;
        toggleDrawer();
        setLoading(false);
        if (reload) {
            catchEditDeliveryInstructionsUpdated(deliveryInstructionInfo.fulfillmentType);
            setReload(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
    };
    var renderSurvey = function () { return (React.createElement("div", null,
        React.createElement("input", { type: "hidden", id: "orderNumberForEditDelivery", value: deliveryInstructionInfo.orderId }),
        React.createElement("input", { type: "hidden", id: "orderOriginForEditDelivery", value: deliveryInstructionInfo.orderOrigin }),
        React.createElement("input", { type: "hidden", id: "storeNumberForEditDelivery", value: deliveryInstructionInfo.storeNumber }),
        React.createElement("input", { type: "hidden", id: "salesDateForEditDelivery", value: deliveryInstructionInfo.salesDate }),
        React.createElement("input", { type: "hidden", id: "fulfillmentTypeForEditDelivery", value: deliveryInstructionInfo.surveyFulfillmentType }),
        React.createElement("input", { type: "hidden", id: "customerTypeForEditDelivery", value: deliveryInstructionInfo.customerType }),
        React.createElement("div", { id: "deliveryinstructionsXPsurvey", "data-testid": "deliveryinstructionsXPsurvey", style: {
                display: 'block',
            } }))); };
    var getNewSiteInstructions = function () {
        var newSiteInstructions = {
            deliveryType: DELIVERY_TYPE_STATUS.THRESHOLD,
            additionalInstructions: additionalInstructions,
            securityCode: securityCode,
            propertyType: propertyType !== 'Other' ? propertyType : otherPropertyType,
            siteConditions: siteConditions,
            hasStairs: hasStairs,
            // trucks36Foot: trucks36Foot ?? false,
            // Temporary change with removale of field for time being
        };
        if (deliveryType === DELIVERY_TYPE_STATUS.LOCKBOX) {
            return __assign(__assign({}, newSiteInstructions), { deliveryType: deliveryType, lockboxCode: lockboxCode, lockboxLocation: lockboxLocation });
        }
        if (deliveryType === DELIVERY_TYPE_STATUS.OUTSIDE) {
            return __assign(__assign({}, newSiteInstructions), { deliveryType: deliveryType, preferredPackagePlacement: preferredPackagePlacement });
        }
        return newSiteInstructions;
    };
    var onSubmit = function () {
        setLoading(true);
        var editDeliveryInstructionsRequest = __assign({ orderId: deliveryInstructionInfo.orderId, emailId: deliveryInstructionInfo.emailId, et: deliveryInstructionInfo.et, fulfillmentType: deliveryInstructionInfo.fulfillmentType, net: deliveryInstructionInfo === null || deliveryInstructionInfo === void 0 ? void 0 : deliveryInstructionInfo.net }, (deliveryInstructionInfo.isEditSiteInstructionsEnabled
            ? { siteInstructions: getNewSiteInstructions() }
            : { newDeliveryInstructions: deliveryInstructions }));
        var traceId = deliveryInstructionInfo === null || deliveryInstructionInfo === void 0 ? void 0 : deliveryInstructionInfo.traceId;
        EditDeliveryInstructionsApi(editDeliveryInstructionsRequest, isAuthTHDUser, deliveryInstructionInfo.xAuthGuestToken, traceId)
            .then(function () {
            setLoading(false);
            setReload(true);
            setAlertState({
                status: 'success',
                alertMessage: EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE.SUCCESS,
                onClose: closeAlert,
            });
            setShowSurvey(true);
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e;
            var errorCode = ((_e = (_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.code) === null || _e === void 0 ? void 0 : _e.toString()) || 'n/a';
            catchEditDeliveryInstructionsPostPageLoadError(errorCode);
            setLoading(false);
            setShowDrawerError(deliveryInstructionInfo.fulfillmentGroupIndex);
            closeDrawer();
        });
    };
    var closeAlert = function () {
        setAlertState(null);
    };
    useEffect(function () {
        setAlertState({
            status: 'info',
            alertMessage: EDIT_DELIVERY_INSTRUCTIONS_ALERT_MESSAGE.DEFAULT,
            onClose: closeAlert,
        });
        setDeliveryInstructions(previousDeliveryInstructions);
        setDeliveryType(deliveryInstructionInfo.deliveryType || '');
        setSecurityCode((previousDeliverySecurity === null || previousDeliverySecurity === void 0 ? void 0 : previousDeliverySecurity.securityCode) || '');
        setLockboxLocation(previousLockboxLocation || '');
        setLockboxCode(previousLockboxCode || '');
        setPreferredPackagePlacement(previousPreferredPackagePlacement || '');
        if (previousPropertyType) {
            setPropertyType(primaryPropertyType ? previousPropertyType : 'Other');
        }
        else {
            setPropertyType('');
        }
        setSiteConditions(previousSiteConditions || '');
        setAdditionalInstructions(previousComments || '');
        setOtherPropertyType(previousPropertyType && !primaryPropertyType ? previousPropertyType : '');
        setHasStairs(booleanStairs);
        setTrucks36Foot(booleanTrucks);
    }, [open]);
    useEffect(function () {
        if (showSurvery) {
            setTimeout(function () {
                var _a, _b, _c, _d;
                if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                    (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.load();
                    (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.run();
                }
            }, 100);
        }
    });
    var handleClearAllButton = function () {
        setDeliveryInstructions('');
        setSecurityCode('');
        setLockboxLocation('');
        setLockboxCode('');
        setPreferredPackagePlacement('');
        setPropertyType('');
        setSiteConditions('');
        setAdditionalInstructions('');
        setOtherPropertyType('');
        setHasStairs(null);
        setTrucks36Foot(false);
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96" },
        React.createElement(Drawer, { open: open, onClose: closeDrawer, position: "right" },
            React.createElement(DrawerHeader, { title: "Edit Delivery Instructions", endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: function () { return closeDrawer(); }, icon: Close }) }),
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4" },
                    alertState && (React.createElement(AlertBanner, { onClose: alertState === null || alertState === void 0 ? void 0 : alertState.onClose, status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || 'info' }, alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage)),
                    showSurvery ? (React.createElement(ErrorBoundary, { name: "edit-pickup-survey" }, renderSurvey())) : (React.createElement("div", { className: "sui-overflow-y-auto responsive-overflow" },
                        React.createElement("div", { className: "sui-text-right sui-pr-5" },
                            React.createElement(Link, { component: "button", onClick: function () { return handleClearAllButton(); } }, "Clear All")),
                        deliveryInstructionInfo.isEditSiteInstructionsEnabled ? (React.createElement(ProOrderUpForm, null)) : (React.createElement("div", { className: "sui-pb-5" },
                            React.createElement(TextField, { id: "deliver-instructions-drawer-input", label: "Add Instructions to Driver", placeholder: instructionsPlaceholder, optional: true, value: deliveryInstructions, onChange: function (event) {
                                    if (event.target.value.match(/^.{0,200}$/)) {
                                        setDeliveryInstructions(event.target.value);
                                    }
                                }, fullWidth: true, multiline: true, maxRows: 5 }))))))),
            React.createElement(DrawerFooter, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2 sui-mt-8" }, showSurvery ? (React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "secondary", onClick: function () { return closeDrawer(); } }, "Close"))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "card-fix sui-pb-2" },
                        React.createElement(LoadingButton, { onClick: onSubmit, loading: loading }, "Save Changes")),
                    React.createElement("div", { className: classNames('card-fix', {
                            'ios-bottom-fix': isIosMobile,
                        }) },
                        React.createElement(Button, { variant: "secondary", onClick: function () {
                                closeDrawer();
                            } }, "Cancel")))))))));
};
